export default __webpack_public_path__ + "static/media/cryptocurrency.dd3cd2b1.png";